import { Stack, Typography, useTheme } from "@mui/material";
import { Icon } from "@iconify/react";

import { Strings } from "@app/constants"; 

import { FilterHeadersProps } from "../../types";

const FilterHeader = ({ selectedCount, handleClear }: FilterHeadersProps) => {
  const theme = useTheme();
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="h6">Filters</Typography>

        <Stack sx={{ position: "relative", display: "inline-flex" }}>
          <Icon
            icon="circum:filter"
            style={{ height: 24, width: 24, color: "black" }}
          />

          {selectedCount > 0 && (
            <Stack
              sx={{
                position: "absolute",
                top: -6,
                right: -6,
                background: theme.palette.primary.main,
                color: "white",
                width: 18,
                height: 18,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "11px",
                fontWeight: "bold",
              }}
            >
              {selectedCount}
            </Stack>
          )}
        </Stack>
      </Stack>

      <Typography
        variant="h6"
        onClick={handleClear}
        sx={{ cursor: "pointer", fontWeight: 500 }}
      >
        {Strings.filters.clear}
      </Typography>
    </Stack>
  );
};

export { FilterHeader };
